module.exports = __webpack_public_path__ + "static/media/image-slash.491ee577.svg";